export enum Environment {
  Debug = 'debug',
  QA = 'qa',
  Production = 'production',
  Sandbox = 'sandbox',
  Staging = 'staging'
}
